
























import {Component, Prop, Vue} from 'vue-property-decorator'
import {TokenPricedCollection} from '@/model/collection/TokenPricedCollection'

@Component({})
export default class TokenPricedVisibleToggleButton extends Vue {
  @Prop({type: Object, required: true}) collection!: TokenPricedCollection

  value = true

  mounted() {
    this.value = this.collection.isVisible ?? true
  }

  changeValue() {
    this.value = !this.value

    this.collection.isVisible = this.value

    this.$emit('filter', this.value)
  }
}
